const _excluded = ["trigger", "variant", "renderTarget", "delayShow", "delayHide"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import Tooltip from '../Tooltip';
const defaultRenderBody = props => /*#__PURE__*/React.createElement(Tooltip.Body, _extends({}, props, {
  padding: 16
}));
const defaultRenderTarget = props => /*#__PURE__*/React.createElement(Tooltip.Target, _extends({}, props, {
  shouldWrapChildren: false
}));
const Flyout = _ref => {
  let {
      trigger = Tooltip.TRIGGER_EVENTS.CLICK,
      variant = Tooltip.VARIANTS.LIGHT,
      renderTarget = defaultRenderTarget,
      delayShow = 100,
      delayHide = 0
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Tooltip, _extends({
    trigger: trigger,
    variant: variant,
    renderBody: defaultRenderBody,
    delayShow: delayShow,
    delayHide: delayHide,
    renderTarget: renderTarget
  }, props));
};
Flyout.displayName = 'Flyout';
Flyout.propTypes = Tooltip.propTypes;
export default Object.assign(Flyout, {
  Arrow: Tooltip.Arrow,
  Target: Tooltip.Target,
  Body: Tooltip.Body,
  VARIANTS: Tooltip.VARIANTS,
  PLACEMENTS: Tooltip.PLACEMENTS,
  TRIGGER_EVENTS: Tooltip.TRIGGER_EVENTS,
  TRIGGER_TARGETS: Tooltip.TRIGGER_TARGETS
});
//# sourceMappingURL=Flyout.js.map